import React, { useMemo } from 'react';
import { ILayerProps } from '@/version-types';
import { computeCropViewModel } from '../core/view-model';
import CropBoundary from './crop-boundary';
import CropGrid from './grid';
import ImageScaleAction from './image-scale-action';
import LayerResizeAction from './layer-resize-action';
import MoveAction from './move-action';
import RotateAction from './rotate-action';
import ScaleAction from './scale-action';
import './image-operate.less';
import './layer-operate.less';

const CropStage: React.FC<{
    layer: ILayerProps;
    stageScale: number;
    isAutoCutoutLayer: boolean;
}> = ({ layer, stageScale, isAutoCutoutLayer }) => {
    const vm = useMemo(() => computeCropViewModel(layer, stageScale), [layer, stageScale]);

    return (
        <>
            <div className="c-crop-image-layerOperate" style={{ zIndex: 1 }}>
                <div className="layer-mask">
                    <div style={vm.flipStyle}>
                        <div style={vm.imageInnerStyle}>
                            <img
                                crossOrigin="anonymous"
                                style={vm.imgStyle}
                                src={vm.url}
                                width={vm.naturalWidth}
                                height={vm.naturalHeight}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="c-crop-image-operate">
                <div style={vm.flipStyle}>
                    <div style={vm.imageInnerStyle}>
                        <div className="img-gray-mask" />
                        <MoveAction width={vm.moveWidth} height={vm.moveHeight} />
                        <ImageScaleAction rotate={layer.rotate} />
                        <RotateAction rotate={layer.rotate} scale={stageScale} />
                    </div>
                </div>
            </div>

            <div className="c-crop-image-layerOperate">
                <div className="layer-mask" style={vm.maskStyle}>
                    <div style={vm.flipStyle}>
                        <div style={vm.imageInnerStyle}>
                            <img
                                crossOrigin="anonymous"
                                style={vm.imgStyle}
                                src={vm.url}
                                width={vm.naturalWidth}
                                height={vm.naturalHeight}
                            />
                        </div>
                    </div>
                </div>

                <CropBoundary />
                <ScaleAction rotate={layer.rotate} />
                <CropGrid />
                {isAutoCutoutLayer ? <LayerResizeAction /> : null}
            </div>
        </>
    );
};

export default CropStage;
